<div class="input-wrapper mb-2" [formGroup]="form">
  <label for="accounts">{{ 'USER_FORM.ACCOUNTS' | translate }}*</label>
  <div class="accounts-group-list">
    @for (account of availableAccounts; track account) {
      <div class="account-group mb-3">
        <div class="accounts-checkbox-list d-flex flex-wrap gap-3">
          <div class="form-check" style="min-width: 180px">
            <input
              #accountCheckbox
              class="form-check-input"
              type="checkbox"
              [id]="'account-' + account.id"
              [checked]="isAccountSelected(account)"
              (change)="onAccountSelection(account, accountCheckbox.checked)"
              [disabled]="!isCurrentUserAdmin"
              />
            <label class="form-check-label" [for]="'account-' + account.id">
              {{ account.name }}
            </label>
          </div>
        </div>
      </div>
    }
  </div>
  @if (form.get('selectedAccounts')?.invalid && form.get('selectedAccounts')?.touched) {
    <div
      class="invalid-feedback d-block"
      >
      {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
    </div>
  }
</div>
